'use client';

import 'swiper/css';
import 'swiper/css/navigation';
import { CldImage } from 'next-cloudinary';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';

interface GallerySliderProps {
  galleryData: {
    imageId: string;
  }[];
}

const GallerySlider = ({ galleryData }: GallerySliderProps) => {
  if (galleryData?.length === 0) {
    return <p>Something Went Wrong</p>;
  }

  return (
    <Swiper
      modules={[Autoplay]}
      slidesPerView={1}
      spaceBetween={20}
      autoplay={{
        delay: 5000,
        disableOnInteraction: false,
      }}
      loop={true}
      speed={800}
      breakpoints={{
        640: {
          slidesPerView: 1,
        },
        1024: {
          slidesPerView: 2,
        },
        1280: {
          slidesPerView: 3,
        },
      }}
      style={{ width: '100%' }}
    >
      {galleryData?.map((item, index) => (
        <SwiperSlide key={index}>
          <div className="flex flex-col p-6 gap-6 w-full h-[35rem] items-center justify-center rounded-3xl bg-[#FFFEFC]">
            <div className="relative w-full h-full aspect-16/17 overflow-hidden rounded-2xl">
              <CldImage
                fill
                format="auto"
                loading="lazy"
                quality="auto"
                src={item.imageId}
                className="object-cover"
                alt="Images from our gallery"
              />
            </div>
          </div>
        </SwiperSlide>
      ))}
    </Swiper>
  );
};

export default GallerySlider;
